/**
 * DIV-039 (#199, #200, #201): the base stylesheet carries years of per-theme
 * "hide the native price / variant picker / buy buttons" rules. Until DIV-034
 * that stylesheet was requested only once a calculator was known to exist for
 * the page, so those rules never reached a product page without a calculator.
 * DIV-034/035 put it in plugins.css at boot on every product page — and the
 * rules hid native prices and variant pickers on non-calculator products
 * store-wide (Streamline, Eurus, Warehouse themes).
 *
 * Every theme-targeting rule in src/styles/store-base.css is now prefixed with
 * `:where(html.cpc-calculator-page)` — zero extra specificity, so the cascade
 * on calculator pages is byte-for-byte what it was — and this marker is set at
 * exactly the moments the stylesheet used to be requested: a calculator id is
 * known for the page (product and non-product paths), or the builder preview
 * renders. A page that never gets here keeps its theme untouched.
 */
export function markCalculatorPage(): void {
  document.documentElement.classList.add("cpc-calculator-page");
}
